// import * as React from "react";
// import { maxHscMembers } from "../../../consts/consts";
// import Alert from "../../Alert";
// import Dropdown from "../../Dropdown/Dropdown";
// import Input from "../../Input-new/Input";
// import SelectTeam from "../../SelectTeam-new/SelectTeam";
// import {priceToNumber} from "../CRUDProperty";

// const PropertyPayments = ({paymentsData, propertyData, handleChangeDropdown, handleChangeInput, viewMode, deleted, isAgent, handleAddMember, isReferral, isHsc}) => {
//     const theme = 'white';
//     const decimals = 2;
//     const percentageDecimals = 2;
//     const feeAmount = isHsc ? propertyData.HSC_LIST_FEE : isReferral ? propertyData.REFERRAL_FEE : propertyData.POTENTIAL_FEE;
//     const grossFeeKey = isHsc ? 'HSC_TEAM_MEMBER_GROSS_FEE':'STRIVE_TEAM_MEMBER_GROSS_FEE'
//     const netFeeKey = isHsc ? 'HSC_TEAM_MEMBER_NET_FEE':'STRIVE_TEAM_MEMBER_NET_FEE'
    
//     if(isHsc)
//         paymentsData = new Array(maxHscMembers).fill(null).map((el, index) => {return {
//                 HSC_TEAM_MEMBER_ID:propertyData[`HSC_TEAM_MEMBER_${index+1}`],
//                 HSC_TEAM_MEMBER_PERCENT:propertyData[`HSC_TEAM_MEMBER_${index+1}_PERCENT`],
//                 HSC_TEAM_MEMBER_NET_FEE:propertyData[`HSC_TEAM_MEMBER_${index+1}_NET_FEE`] ? propertyData[`HSC_TEAM_MEMBER_${index+1}_NET_FEE`].toLocaleString() : null,
//                 HSC_TEAM_MEMBER_NET_PERCENT:propertyData[`HSC_TEAM_MEMBER_${index+1}_NET_PERCENT`],
//                 HSC_TEAM_MEMBER_GROSS_FEE:propertyData[`HSC_TEAM_MEMBER_${index+1}_GROSS_FEE`] ? propertyData[`HSC_TEAM_MEMBER_${index+1}_GROSS_FEE`].toLocaleString() : null
//             }
//         });

//     function computeTotalGross() {
//         if (!paymentsData)
//             return null;
//         let sum = 0;
//         paymentsData.forEach(elem => sum += elem[grossFeeKey] ? priceToNumber(elem[grossFeeKey]) : 0);
//         return sum.toFixed(decimals);
//     }

//     function computeTotalNet() {
//         if (!paymentsData)
//             return null;
//         let sum = 0;
//         paymentsData.forEach(elem => sum += elem[netFeeKey] ? priceToNumber(elem[netFeeKey]) : 0);
//         return sum.toFixed(decimals);
//     }

//     function totalGrossIsStriveFee() {
//         return feeAmount && computeTotalGross() === Number(feeAmount.replace(',', '')).toFixed(decimals);
//     }

//     return (
//         <React.Fragment>
//             <div className="Property-payments_actions">
//                 <Input
//                     className="Property-payments_column_item"
//                     type="text"
//                     valueType="float"
//                     name={isHsc ? "HSC_LIST_FEE" : isReferral ? "REFERRAL_FEE" : "POTENTIAL_FEE"}
//                     label={isHsc ? "HSC Fee":"STRIVE Fee"}
//                     value={feeAmount}
//                     viewMode={viewMode}
//                     deleted={deleted}
//                     isDollar
//                     disabled
//                     decimals={decimals}
//                 />
//                 {
//                     !totalGrossIsStriveFee() &&
//                     <Alert type='error'> The total Gross Commission does not equal the {isHsc ? 'HSC': 'STRIVE'} Total Fee </Alert>
//                 }
//             </div>
//             <div className={`Property-payments ${isHsc?'HSC':''}`}>
//                 <div className="Property-payments_column">
//                     {
//                         paymentsData && paymentsData.map((data, index) => (
//                             isHsc ? 
//                             <Dropdown
//                                 optionsType='team-members'
//                                 optionLabelKey='NAME'
//                                 optionKey={"EMAIL"}
//                                 key={`${index}-TEAM`}
//                                 className="Property-payments_column_item"
//                                 valueKey={`HSC_TEAM_MEMBER_ID`}
//                                 percentKey={`HSC_TEAM_MEMBER_PERCENT`}
//                                 isFromProperty
//                                 value={data.HSC_TEAM_MEMBER_ID}
//                                 label={`HSC Team Member ${index + 1}`}
//                                 percentLabel='Member %'
//                                 data={paymentsData[index]}
//                                 hasAgentPercent={true}
//                                 handleParentChange={(data, optionsType, reason, key) => {
//                                     handleChangeDropdown({index, data, key})
//                                 }}
//                                 handleInputParentChange={(key, value) =>
//                                     handleChangeInput({index, key, value})
//                                 }
//                                 viewMode={viewMode}
//                                 deleted={deleted}
//                                 disabled={isAgent}
//                             />
//                             :
//                             <SelectTeam
//                                 key={`${index}-TEAM`}
//                                 className="Property-payments_column_item"
//                                 valueKey='STRIVE_TEAM_MEMBER_ID'
//                                 percentKey='STRIVE_TEAM_MEMBER_PERCENT'
//                                 isFromProperty
//                                 value={data.STRIVE_TEAM_MEMBER_ID}
//                                 label={`Strive Team Member ${index + 1}`}
//                                 percentLabel='Member %'
//                                 data={paymentsData[index]}
//                                 hasAgentPercent={true}
//                                 handleParentChange={(data, optionsType, reason, key) => {
//                                     handleChangeDropdown({index, data, key})
//                                 }}
//                                 handleInputParentChange={(key, value) =>
//                                     handleChangeInput({index, key, value})
//                                 }
//                                 viewMode={viewMode}
//                                 deleted={deleted}
//                                 disabled={isAgent}
//                             />
//                         ))
//                     }
//                     {
//                         !viewMode && !isHsc &&
//                         <button
//                             type="button"
//                             className="button-new positive add-member-button"
//                             onClick={handleAddMember}>
//                             Add member
//                         </button>
//                     }
//                 </div>
//                 <div className="Property-payments_column">
//                     {
//                         paymentsData && paymentsData.map((data, index) => (
//                             <Input
//                                 className="Property-payments_column_item"
//                                 key={`${index}-${grossFeeKey}`}
//                                 theme={theme}
//                                 type="text"
//                                 valueType="float"
//                                 label='Gross Commission'
//                                 value={data[grossFeeKey]}
//                                 disabled
//                                 isDollar
//                                 viewMode={viewMode}
//                                 decimals={decimals}
//                             />
//                         ))
//                     }
//                     <Input
//                         className="Property-payments_column_item"
//                         type="text"
//                         valueType="float"
//                         label="Total Gross Commission"
//                         value={computeTotalGross()}
//                         isDollar
//                         disabled
//                         viewMode={viewMode}
//                         decimals={decimals}
//                     />
//                 </div>
//                 <div className="Property-payments_column">
//                     {
//                         paymentsData && paymentsData.map((data, index) => (
//                             <Input
//                                 className="Property-payments_column_item"
//                                 key={`${index}-${netFeeKey}`}
//                                 theme={theme}
//                                 type="text"
//                                 valueType="float"
//                                 label='Net Commission'
//                                 value={data[netFeeKey]}
//                                 disabled
//                                 isDollar
//                                 viewMode={viewMode}
//                                 decimals={decimals}
//                             />
//                         ))
//                     }
//                     <Input
//                         className="Property-payments_column_item"
//                         type="text"
//                         valueType="float"
//                         label="Total Net Commission"
//                         value={computeTotalNet()}
//                         isDollar
//                         disabled
//                         viewMode={viewMode}
//                         decimals={decimals}
//                     />
//                 </div>
//                 <div className="Property-payments_column">
//                     {
//                         paymentsData && paymentsData.map((data, index) => (
//                             <Input
//                                 key={`${index}-PERCENTAGE`}
//                                 className='Property-payments_column_item'
//                                 type='text'
//                                 valueType='percent'
//                                 label='%'
//                                 value={isHsc ? data.HSC_TEAM_MEMBER_NET_PERCENT : data.STRIVE_TEAM_MEMBER_NET_PERCENT || ''}
//                                 viewMode={viewMode}
//                                 deleted={deleted}
//                                 disabled
//                                 decimals={percentageDecimals}
//                             />
//                         ))
//                     }
//                 </div>
//                 { !isHsc &&
//                     <div className="Property-payments_column">
//                         {
//                             paymentsData && paymentsData.map((data, index) => {
//                                 if(!viewMode && data.STRIVE_TEAM_MEMBER_ID)
//                                     return(
//                                         <div className="Property-payments_column_item">
//                                             <button key={`${index}-REMOVE`} type='button' className='button-new negative' 
//                                             onClick={()=>handleChangeInput({key:'DELETED',value:'1',index})}>Remove</button>
//                                         </div>
//                                     )
//                             })
//                         }
//                     </div>
//                 }
//             </div>
//         </React.Fragment>
//     );
// };

// export default PropertyPayments;

import * as React from "react";
import { maxHscMembers } from "../../../consts/consts";
import Alert from "../../Alert";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import SelectTeam from "../../SelectTeam-new/SelectTeam";
import {priceToNumber} from "../CRUDProperty";
import hscTeamMembers from "../../../hsc-team-members";
import { fetchData } from "../../Service/graphQlService";
import { GET_CONTACT_TEAM_LIST_QUERY } from "../../Graphql/ContactsQueries/contactsQuery";

const PropertyPayments = ({paymentsData, propertyData, handleChangeDropdown, handleChangeInput, viewMode, deleted, isAgent, handleAddMember, isReferral, isHsc}) => {
    const theme = 'white';
    const decimals = 2;
    const percentageDecimals = 2;

    // HSC team members are picked from a static list keyed by EMAIL. When a
    // member is removed from that list, an already-assigned HSC member would no
    // longer resolve and the name would render blank. Resolve any assigned email
    // that is missing from the static list (falling back to the email itself).
    const [extraHscOptions, setExtraHscOptions] = React.useState([]);

    const hscAssignedKey = isHsc
        ? Array.from({ length: maxHscMembers }, (_, i) => propertyData[`hsc_team_member_${i + 1}`] || '').join('|')
        : '';

    React.useEffect(() => {
        if (!isHsc) return undefined;
        const assignedEmails = hscAssignedKey.split('|').filter(Boolean);
        const known = new Set(hscTeamMembers.map((m) => (m.EMAIL || '').toLowerCase()));
        const missing = assignedEmails.filter((e) => !known.has(String(e).toLowerCase()));
        if (!missing.length) {
            setExtraHscOptions((prev) => (prev.length ? [] : prev));
            return undefined;
        }

        let cancelled = false;
        Promise.all(
            missing.map((email) =>
                fetchData(GET_CONTACT_TEAM_LIST_QUERY, { type: 'Team', filters: [{ email }] })
                    .then((res) => {
                        const rec =
                            res && res.data && res.data.getContacts && res.data.getContacts.data
                                ? res.data.getContacts.data[0]
                                : null;
                        const name =
                            rec && (rec.first_name || rec.last_name)
                                ? `${rec.first_name || ''} ${rec.last_name || ''}`.trim()
                                : email;
                        return { NAME: name, EMAIL: email };
                    })
                    .catch(() => ({ NAME: email, EMAIL: email }))
            )
        ).then((resolved) => {
            if (!cancelled) setExtraHscOptions(resolved);
        });
        return () => {
            cancelled = true;
        };
    }, [isHsc, hscAssignedKey]);

    const hscOptions = React.useMemo(
        () => hscTeamMembers.concat(extraHscOptions),
        [extraHscOptions]
    );
    const feeAmount = isHsc ? propertyData.hsc_list_fee : isReferral ? propertyData.referral_fee : propertyData.potential_fee;
    const grossFeeKey = isHsc ? 'hsc_team_member_gross_fee':'strive_team_member_gross_fee'
    const netFeeKey = isHsc ? 'hsc_team_member_net_fee':'strive_team_member_net_fee'
    
    if(isHsc)
        paymentsData = new Array(maxHscMembers).fill(null).map((el, index) => {return {
                hsc_team_member_id:propertyData[`hsc_team_member_${index+1}`],
                hsc_team_member_percent:propertyData[`hsc_team_member_${index+1}_percent`],
                hsc_team_member_net_fee:propertyData[`hsc_team_member_${index+1}_net_fee`] ? propertyData[`hsc_team_member_${index+1}_net_fee`].toLocaleString() : null,
                hsc_team_member_net_percent:propertyData[`hsc_team_member_${index+1}_net_percent`],
                hsc_team_member_gross_fee:propertyData[`hsc_team_member_${index+1}_gross_fee`] ? propertyData[`hsc_team_member_${index+1}_gross_fee`].toLocaleString() : null
            }
        });

    function computeTotalGross() {
        if (!paymentsData)
            return null;
        let sum = 0;
        paymentsData.forEach(elem => sum += elem[grossFeeKey] ? priceToNumber(elem[grossFeeKey]) : 0);
        return sum.toFixed(decimals);
    }

    function computeTotalNet() {
        if (!paymentsData)
            return null;
        let sum = 0;
        paymentsData.forEach(elem => sum += elem[netFeeKey] ? priceToNumber(elem[netFeeKey]) : 0);
        return sum.toFixed(decimals);
    }

    function totalGrossIsStriveFee() {

        if (!feeAmount && !(parseFloat(computeTotalGross()))) {
            return true;
        }
        return feeAmount && computeTotalGross() === Number(feeAmount.replace(',', '')).toFixed(decimals);
    }

    return (
        <React.Fragment>
            <div className="Property-payments_actions">
                <Input
                    className="Property-payments_column_item"
                    type="text"
                    valueType="float"
                    name={isHsc ? "hsc_list_fee" : isReferral ? "referral_fee" : "potential_fee"}
                    label={isHsc ? "AthCap Fee":"STRIVE Fee"}
                    value={feeAmount}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                    disabled
                    decimals={decimals}
                />
                {
                    !totalGrossIsStriveFee()  &&
                    <Alert type='error'> The total Gross Commission does not equal the {isHsc ? 'HSC': 'STRIVE'} Total Fee </Alert>
                }
            </div>
            <div className={`Property-payments ${isHsc?'HSC':''}`}>
                <div className="Property-payments_column">
                    {
                        paymentsData && paymentsData.map((data, index) => (
                            isHsc ? 
                            <Dropdown
                                optionsType='team-members'
                                options={hscOptions}
                                optionLabelKey='NAME'
                                optionKey={"EMAIL"}
                                key={`${index}-team`}
                                className="Property-payments_column_item"
                                valueKey={`hsc_team_member_id`}
                                percentKey={`hsc_team_member_percent`}
                                isFromProperty
                                value={data.hsc_team_member_id}
                                label={`HSC Team Member ${index + 1}`}
                                percentLabel='Member %'
                                data={paymentsData[index]}
                                hasAgentPercent={true}
                                handleParentChange={(data, optionsType, reason, key) => {
                                    handleChangeDropdown({index, data, key})
                                }}
                                handleInputParentChange={(key, value) =>
                                    handleChangeInput({index, key, value})
                                }
                                viewMode={viewMode}
                                deleted={deleted}
                                disabled={isAgent}
                            />
                            :
                            <SelectTeam
                                key={`${index}-team`}
                                className="Property-payments_column_item"
                                valueKey='strive_team_member_id'
                                percentKey='strive_team_member_percent'
                                isFromProperty
                                value={data.strive_team_member_id}
                                label={`Strive Team Member ${index + 1}`}
                                percentLabel='Member %'
                                data={paymentsData[index]}
                                hasAgentPercent={true}
                                handleParentChange={(data, optionsType, reason, key) => {
                                    handleChangeDropdown({index, data, key})
                                }}
                                handleInputParentChange={(key, value) =>
                                    handleChangeInput({index, key, value})
                                }
                                viewMode={viewMode}
                                deleted={deleted}
                                disabled={isAgent}
                            />
                        ))
                    }
                    {
                        !viewMode && !isHsc &&
                        <button
                            type="button"
                            className="button-new positive add-member-button"
                            onClick={handleAddMember}>
                            Add member
                        </button>
                    }
                </div>
                <div className="Property-payments_column">
                    {
                        paymentsData && paymentsData.map((data, index) => (
                            <Input
                                className="Property-payments_column_item"
                                key={`${index}-${grossFeeKey}`}
                                theme={theme}
                                type="text"
                                valueType="float"
                                label='Gross Commission'
                                value={data[grossFeeKey]}
                                disabled
                                isDollar
                                viewMode={viewMode}
                                decimals={decimals}
                            />
                        ))
                    }
                    <Input
                        className="Property-payments_column_item"
                        type="text"
                        valueType="float"
                        label="Total Gross Commission"
                        value={computeTotalGross()}
                        isDollar
                        disabled
                        viewMode={viewMode}
                        decimals={decimals}
                    />
                </div>
                <div className="Property-payments_column">
                    {
                        paymentsData && paymentsData.map((data, index) => (
                            <Input
                                className="Property-payments_column_item"
                                key={`${index}-${netFeeKey}`}
                                theme={theme}
                                type="text"
                                valueType="float"
                                label='Net Commission'
                                value={data[netFeeKey]}
                                disabled
                                isDollar
                                viewMode={viewMode}
                                decimals={decimals}
                            />
                        ))
                    }
                    <Input
                        className="Property-payments_column_item"
                        type="text"
                        valueType="float"
                        label="Total Net Commission"
                        value={computeTotalNet()}
                        isDollar
                        disabled
                        viewMode={viewMode}
                        decimals={decimals}
                    />
                </div>
                <div className="Property-payments_column">
                    {
                        paymentsData && paymentsData.map((data, index) => (
                            <Input
                                key={`${index}-percentage`}
                                className='Property-payments_column_item'
                                type='text'
                                valueType='percent'
                                label='%'
                                value={isHsc ? data.hsc_team_member_net_percent : data.strive_team_member_net_percent || ''}
                                viewMode={viewMode}
                                deleted={deleted}
                                disabled
                                decimals={percentageDecimals}
                            />
                        ))
                    }
                </div>
                { !isHsc &&
                    <div className="Property-payments_column">
                        {
                            paymentsData && paymentsData.map((data, index) => {
                                if(!viewMode && data.strive_team_member_id)
                                    return(
                                        <div className="Property-payments_column_item">
                                            <button key={`${index}-REMOVE`} type='button' className='button-new negative' 
                                            onClick={()=>handleChangeInput({key:'deleted',value:'1',index})}>Remove</button>
                                        </div>
                                    )
                            })
                        }
                    </div>
                }
            </div>
        </React.Fragment>
    );
};

export default PropertyPayments;
